import { get, put } from '@api/request';

export async function fetchStatistics({ appealsService }, authenticationToken) {
  const url = `${appealsService}/prodigyappeals/statistics?userToShow=all`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getDashboardDefaultTaxingUnit(
  { appealsService },
  authenticationToken,
) {
  let url = `${appealsService}/prodigyappeals/appeals/configuration/general`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getTotalCases(
  { appealsService },
  authenticationToken,
  { pYear, taxingUnitID },
) {
  let url = `${appealsService}/prodigyappeals/appealsdashboard/totalcases/${pYear}`;
  if(taxingUnitID) {
    url = `${url}?taxingUnitID=${taxingUnitID}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getPropTypes(
  { appealsService },
  authenticationToken,
  { pYear },
) {
  const url = `${appealsService}/prodigyappeals/appealsdashboard/proptype/${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getDashboardDetail(
  { appealsService },
  authenticationToken,
  { type },
) {
  const url = `${appealsService}/prodigyappeals/appealsdashboard/dashboard/${type}/details`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getAppealTypes(
  { appealsService },
  authenticationToken,
  { pYear },
) {
  const url = `${appealsService}/prodigyappeals/appealsdashboard/appealtype/${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getTeamFormal(
  { appealsService },
  authenticationToken,
  { pYear },
) {
  const url = `${appealsService}/prodigyappeals/appealsdashboard/team/formal/${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getTeamInformal(
  { appealsService },
  authenticationToken,
  { pYear },
) {
  const url = `${appealsService}/prodigyappeals/appealsdashboard/team/informal/${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getTeamProductivity(
  { appealsService },
  authenticationToken,
  { pYear, queryString, type },
) {
  const url = `${appealsService}/prodigyappeals/appealsdashboard/productivitylog/${type}/${pYear}${queryString}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getFormalDates(
  { appealsService },
  authenticationToken,
  { pYear },
) {
  const url = `${appealsService}/prodigyappeals/appealsdashboard/formaldates/${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getInformalDates(
  { appealsService },
  authenticationToken,
  { pYear },
) {
  const url = `${appealsService}/prodigyappeals/appealsdashboard/informaldates/${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function get14DayData(
  { appealsService },
  authenticationToken,
  { pYear },
) {
  const url = `${appealsService}/prodigyappeals/appealsdashboard/14days/${pYear}`;
  let { body } = await get(authenticationToken, url);
  if (body && body.results && body.results.length > 0) {
    body.results = body.results.sort(
      (a, b) => new Date(a.docketDt) - new Date(b.docketDt),
    );
  }
  return body;
}

export async function getNotScheduled(
  { appealsService },
  authenticationToken,
  { pYear },
) {
  const url = `${appealsService}/prodigyappeals/appealsdashboard/notscheduled/${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateDashboard(
  { appealsService },
  authenticationToken,
  { dashboardID, payload },
) {
  const url = `${appealsService}/prodigyappeals/appealsdashboard/dashboard/${dashboardID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function copyDashboard(
  { appealsService },
  authenticationToken,
  { pYear },
) {
  const url = `${appealsService}/prodigyappeals/appealsdashboard/notscheduled/${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}
